import React, { useState } from "react";
import { Button } from "reactstrap";
import Switch from "react-switch";
import { switchState, deleteQuestion } from "./Axios";

const DefaultQuestionHit = ({ index, question, showNotification, removeQuestion }) => {
  const [questionData, setQuestionData] = useState(question);
  const [checked, setChecked] = useState(question.aasm_state === "active");

  const handleSwitchState = () => {
    let switch_state = checked ? "deactivate" : "activate";
    const formData = new FormData();
    formData.append("switch_state", switch_state);

    switchState(question.id, formData, response => {
      if (response.status === 200) {
        setChecked(!checked);
        setQuestionData(response.data);
        showNotification("Genial", "Estado cambiado con éxito!", "success");
      } else {
        showNotification("Ops", "Error al cambiar de estado!", "danger");
      }
    });
  };

  const handleDelete = () => {
    if (window.confirm("¿Estás seguro de que quieres eliminar esta pregunta?")) {
      deleteQuestion(question.id, response => {
        if (response.status === 200) {
          showNotification("Eliminado", "Pregunta eliminada con éxito", "success");
          removeQuestion(question.id);
        } else {
          showNotification("Error", "No se pudo eliminar la pregunta", "danger");
        }
      });
    }
  };

  const formatAnswerType = (type) => {
    switch (type) {
      case "text":
        return "Texto";
      case "number":
        return "Número";
      case "boolean":
        return "Sí / No";
      case "single_choice":
        return "Selección única";
      case "multiple_choice":
        return "Selección múltiple";
      default:
        return "-";
    }
  };

  return (
    <tr>
      <td>{index}</td>
      <td>
        {questionData.question}
        {["single_choice", "multiple_choice"].includes(questionData.answer_type) && (
          <ul className="mb-0 small text-muted">
            {(questionData.options || []).map((opt, i) => (
              <li key={i}>{opt}</li>
            ))}
          </ul>
        )}
      </td>
      <td>{formatAnswerType(questionData.answer_type)}</td>
      <td>
        <Switch
          checked={checked}
          onChange={handleSwitchState}
          onColor="#00c851"
          offColor="#ff3547"
        />
      </td>
      <td>
        <Button color="danger" size="sm" onClick={handleDelete}>
          <i className="fas fa-trash"></i>
        </Button>
      </td>
    </tr>
  );
};

export default DefaultQuestionHit;
